// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.survey-form-radio-buttons-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.survey-form-radio-buttons-list .survey-form-radio-button-container {
  position: relative;
  font-size: 14px;
  line-height: 24px;
  color: #3a3f52;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
}
.survey-form-radio-buttons-list .survey-form-radio-button-container .survey-form-radio-button-outline-effect {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  background: rgba(106, 100, 241, 0.025);
  padding: 5px 10px;
  border: 1px solid rgba(106, 100, 241, 0.1);
  border-radius: 4px;
}
.survey-form-radio-buttons-list .survey-form-radio-button-container .survey-form-radio-button-input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.survey-form-radio-buttons-list .survey-form-radio-button-container .survey-form-radio-button-input:checked ~ .survey-form-radio-button-checkmark {
  background-color: #6a64f1;
}
.survey-form-radio-buttons-list .survey-form-radio-button-container .survey-form-radio-button-input:checked ~ span {
  font-weight: bold;
}
.survey-form-radio-buttons-list .survey-form-radio-button-container .survey-form-radio-button-input:not(:checked) ~ .survey-form-radio-button-outline-effect {
  opacity: 0;
}
.survey-form-radio-buttons-list .survey-form-radio-button-container .survey-form-radio-button-input:checked ~ .survey-form-radio-button-outline-effect {
  opacity: 1;
}
.survey-form-radio-buttons-list .survey-form-radio-button-container .survey-form-radio-button-input:checked ~ .survey-form-radio-button-checkmark:after {
  display: block;
}
.survey-form-radio-buttons-list .survey-form-radio-button-container .survey-form-radio-button-checkmark {
  position: relative;
  height: 18px;
  width: 18px;
  background-color: #ffffff;
  border: 1px solid #dde3ec;
  border-radius: 50%;
  margin: 6px 6px;
}
.survey-form-radio-buttons-list .survey-form-radio-button-container .survey-form-radio-button-checkmark:after {
  content: "";
  position: absolute;
  display: none;
  top: 50%;
  left: 50%;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #ffffff;
  transform: translate(-50%, -50%);
}`, "",{"version":3,"sources":["webpack://./src/views/survey/radioQuestionComponent/style.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AACF;AACE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;EAGA,iBAAA;EACA,aAAA;EACA,mBAAA;AACJ;AACI;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,iBAAA;EACA,0CAAA;EACA,kBAAA;AACN;AAEI;EACE,kBAAA;EACA,UAAA;EACA,eAAA;AAAN;AAEM;EACE,yBAAA;AAAR;AAGM;EACE,iBAAA;AADR;AAIM;EACE,UAAA;AAFR;AAIM;EACE,UAAA;AAFR;AAKM;EACE,cAAA;AAHR;AAOI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AALN;AAOM;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EAEA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,gCAAA;AANR","sourcesContent":[".survey-form-radio-buttons-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n\r\n  .survey-form-radio-button-container {\r\n    position: relative;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    color: #3a3f52;\r\n    cursor: pointer;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    display: flex;\r\n    align-items: center;\r\n    \r\n    .survey-form-radio-button-outline-effect {\r\n      position: absolute;\r\n      display: block;\r\n      width: 100%;\r\n      height: 100%;\r\n      background: rgba(106, 100, 241, 0.025);\r\n      padding: 5px 10px;\r\n      border: 1px solid rgba(106, 100, 241, 0.1);\r\n      border-radius: 4px;\r\n    }\r\n\r\n    .survey-form-radio-button-input {\r\n      position: absolute;\r\n      opacity: 0;\r\n      cursor: pointer;\r\n\r\n      &:checked ~ .survey-form-radio-button-checkmark {\r\n        background-color: #6a64f1;\r\n      }\r\n\r\n      &:checked ~ span {\r\n        font-weight: bold;\r\n      }\r\n\r\n      &:not(:checked) ~ .survey-form-radio-button-outline-effect {\r\n        opacity: 0.0;\r\n      }\r\n      &:checked ~ .survey-form-radio-button-outline-effect {\r\n        opacity: 1.0;\r\n      }\r\n\r\n      &:checked ~ .survey-form-radio-button-checkmark:after {\r\n        display: block;\r\n      }\r\n    }\r\n\r\n    .survey-form-radio-button-checkmark {\r\n      position: relative;\r\n      height: 18px;\r\n      width: 18px;\r\n      background-color: #ffffff;\r\n      border: 1px solid #dde3ec;\r\n      border-radius: 50%;\r\n      margin: 6px 6px;\r\n\r\n      &:after {\r\n        content: '';\r\n        position: absolute;\r\n        display: none;\r\n\r\n        top: 50%;\r\n        left: 50%;\r\n        width: 12px;\r\n        height: 12px;\r\n        border-radius: 50%;\r\n        background: #ffffff;\r\n        transform: translate(-50%, -50%);\r\n      }\r\n    }\r\n\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
